import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Text } from '@travel-frontend/core';
import { IconFlightTakeoff } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { Content } from '../../../components/FlightDetails/Header/components/Content.js';
import { Icon } from '../../../components/FlightDetails/Header/components/Icon.js';
import { TextWrapper } from '../../../components/FlightDetails/TextWrapper.js';
import { Notice, Flex } from '../../../primitives/index.js';
import { FLIGHT_DETAILS_QA_ID, qaId } from '../../../utils/qaId.js';
export const Header = ({
  direction,
  title,
  date,
  alert = false,
  highlightDate = false,
  showInvalidDataNotice = false
}) => {
  const {
    t
  } = useTranslation('travelDetailsOverlay');
  return _jsxs(Flex, {
    direction: "column",
    gap: "24px",
    children: [showInvalidDataNotice && _jsx(Notice, {
      variant: "warning",
      children: t('missingDataNotice')
    }), _jsxs(Flex, {
      direction: "row",
      "data-testid": qaId(FLIGHT_DETAILS_QA_ID, `${direction}flight-header`),
      alignItems: "start",
      children: [_jsx(Icon, {
        rotate: direction === 'inbound',
        children: _jsx(IconFlightTakeoff, {})
      }), _jsxs(Content, {
        alert: alert,
        children: [_jsx(Text, {
          preset: "labelXLargeBold",
          children: title
        }), _jsx(Text, {
          preset: "labelSmall",
          "data-testid": "shared-flightLayer-flightDate",
          children: _jsx(TextWrapper, {
            highlighted: highlightDate,
            children: date
          })
        })]
      })]
    })]
  });
};